var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconUnlock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46770",
    "data-name": "Path 46770",
    d: "M89.2,7.214H80.839V4.607a2.786,2.786,0,1,1,5.571-.09.929.929,0,0,0,1.857,0A4.606,4.606,0,0,0,83.161.023,4.719,4.719,0,0,0,78.982,4.7V7.214H77.054a.917.917,0,0,0-.929.9V17.1a.983.983,0,0,0,.929.9H89.2a.915.915,0,0,0,.929-.9V8.113A.864.864,0,0,0,89.2,7.214Zm-4.643,6.022V14.4a.929.929,0,0,1-1.857,0V13.236a1.844,1.844,0,0,1-.929-1.528A1.828,1.828,0,0,1,84.089,10a2.061,2.061,0,0,1,1.393,1.348A1.733,1.733,0,0,1,84.554,13.236Z",
    transform: "translate(-76.125)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconUnlock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_unlock.993069c6d92fc23cb5cd058bda4affc7.svg";